export default __webpack_public_path__ + "static/media/narV61.925f1bb5.jpg";